import { render, staticRenderFns } from "./PcHomeSideNav.vue?vue&type=template&id=6a715572&scoped=true"
import script from "./PcHomeSideNav.vue?vue&type=script&lang=js"
export * from "./PcHomeSideNav.vue?vue&type=script&lang=js"
import style0 from "./PcHomeSideNav.vue?vue&type=style&index=0&id=6a715572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a715572",
  null
  
)

export default component.exports